import React from 'react';
import './MenuItem.css';

export default function MenuItem(props) {
    return (<>
            <i className="material-icons" id = "nav-icon">{props.icon}</i>
            <h2 className="nav-text">{props.text}</h2>
    </>
    );
}